import React, { createContext, useState } from 'react'

export const ClientState = createContext({
  doingPayment: false,
  setDoingPayment: () => {},
  method: null,
  setMethod: () => {},
  ignorePendingPayment: null,
  setIgnorePendingPayment: () => {},
})
const ClientAppContext = ({ children }) => {
  const [method, setMethod] = useState(null)
  const [doingPayment, setDoingPayment] = useState(false)
  const [ignorePendingPayment, setIgnorePendingPayment] = useState(false)

  return (
    <ClientState.Provider
      value={{
        doingPayment,
        setDoingPayment,
        method,
        setMethod,
        ignorePendingPayment,
        setIgnorePendingPayment,
      }}
    >
      {children}
    </ClientState.Provider>
  )
}

export default ClientAppContext
